import AddonModel from "../model/addon_model";

// Helper to extract price as a number from possible { $numberDecimal: "400" } or direct number
const extractPrice = (price) => {
  if (price && typeof price === "object" && price.$numberDecimal !== undefined) {
    return Number(price.$numberDecimal);
  }
  return typeof price === "number" ? price : Number(price) || 0;
};

export const toAddonModel = (data) => {
  return new AddonModel({
    id: data._id,
    key: data.key,
    name: data.name,
    price: extractPrice(data.price),
    unitOfItem: data.unitOfItem,
    unitOfTime: data.unitOfTime,
    isActive: data.isActive,
    value: data.value,
  });
};
